import { jsx as _jsx } from "react/jsx-runtime";
import { AlertFilled, AlertRegular, ClipboardTextLtrFilled, ClipboardTextLtrRegular, SettingsFilled, SettingsRegular } from '@fluentui/react-icons';
import { Badge, BottomNavigation, BottomNavigationAction, Paper, Tooltip, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import useBottomNavigationStyles from './useBottomNavigationStyles';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAlertContext } from '@ui/pages/Alerts/AlertContext';
import incidentsApi from '@application/api/endpoints/incident-api';
const BottomNavbar = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { BottomNavigationActionStyles, AlertBadgeStyles } = useBottomNavigationStyles();
    const { setAlerts, alerts, showTooltip, setShowTooltip } = useAlertContext();
    useEffect(() => {
        const getIncidentAlerts = async () => {
            try {
                const response = await incidentsApi.getIncidentAlerts();
                if (response.isSuccess && response?.data) {
                    setAlerts && setAlerts(response?.data);
                    if (response?.data.criticalIncidentAlert?.length > 0) {
                        setShowTooltip(true);
                    }
                }
            }
            catch (error) { }
        };
        getIncidentAlerts();
    }, []);
    const theme = useTheme();
    const NavigationOptions = [
        {
            id: 0,
            label: t('History'),
            path: '/incident-history',
            icon: _jsx(ClipboardTextLtrRegular, { fontSize: 24 }),
            selectedIcon: _jsx(ClipboardTextLtrFilled, { fontSize: 24 })
        },
        // {
        //   id: 1,
        //   label: t('LiveFeed'),
        //   path: '/live-feed',
        //   icon: <VideoRegular fontSize={24} />,
        //   selectedIcon: <VideoFilled fontSize={24} />
        // },
        {
            id: 1,
            label: t('Alerts'),
            path: '/alerts',
            icon: (_jsx(Tooltip, { open: alerts?.criticalIncidentAlert?.length != null &&
                    alerts?.criticalIncidentAlert?.length > 0
                    ? showTooltip
                    : false, title: `${alerts?.criticalIncidentAlert?.length} Severe Incident detected`, placement: 'bottom', arrow: true, PopperProps: {
                    disablePortal: true,
                    modifiers: [
                        {
                            name: 'zIndex',
                            enabled: true,
                            phase: 'write',
                            fn({ state }) {
                                state.styles.popper.zIndex = `${theme.zIndex.drawer - 1}`;
                            }
                        }
                    ]
                }, componentsProps: {
                    tooltip: {
                        className: 'shake-tooltip',
                        sx: {
                            bgcolor: 'error.main',
                            color: 'common.white',
                            zIndex: `${theme.zIndex.drawer - 1} !important`,
                            fontSize: 12,
                            px: 1.5,
                            py: 0.5,
                            borderRadius: 1
                        }
                    },
                    arrow: {
                        sx: {
                            color: 'error.main'
                        }
                    }
                }, children: _jsx(Badge, { color: 'error', overlap: 'circular', sx: AlertBadgeStyles, invisible: alerts?.allIncidentAlert?.length === 0, badgeContent: alerts?.allIncidentAlert?.length, className: 'alert-badge', children: _jsx(AlertRegular, { fontSize: 24 }) }) }, 0)),
            selectedIcon: (_jsx(Badge, { color: 'error', overlap: 'circular', sx: AlertBadgeStyles, invisible: alerts?.allIncidentAlert?.length === 0, badgeContent: alerts?.allIncidentAlert?.length, className: 'alert-badge', children: _jsx(AlertFilled, { fontSize: 24 }) }))
        },
        {
            id: 2,
            label: t('Settings'),
            path: '/settings',
            icon: _jsx(SettingsRegular, { fontSize: 24 }),
            selectedIcon: _jsx(SettingsFilled, { fontSize: 24 })
        }
    ];
    const getActiveNavItem = () => {
        const activeItem = NavigationOptions.find((navItem) => location.pathname.includes(navItem.path));
        return activeItem ? activeItem.id : 0; // Default to first item if no match found
    };
    const [activeNavItem, setActiveNavItem] = useState(getActiveNavItem());
    let CurrentTab = 0;
    const onChangeNavItem = (_, newValue) => {
        const selectedNavItem = NavigationOptions.find((navItem) => navItem.id === newValue);
        CurrentTab = newValue;
        if (selectedNavItem) {
            navigate(selectedNavItem.path);
            setActiveNavItem(newValue);
        }
    };
    useEffect(() => {
        setActiveNavItem(getActiveNavItem());
    }, [location.pathname]);
    return (_jsx(Paper, { sx: { position: 'fixed', bottom: 0, left: 0, right: 0 }, elevation: 3, children: _jsx(BottomNavigation, { showLabels: true, value: activeNavItem, onChange: onChangeNavItem, children: NavigationOptions.map((navItem, index) => (_jsx(BottomNavigationAction, { label: navItem.label, 
                // disabled={index === 0 ? false : true}
                icon: activeNavItem === navItem.id ? navItem.selectedIcon : navItem.icon, sx: {
                    ...BottomNavigationActionStyles,
                    color: index === 0 ? '' : '#9e9e9e'
                } }, `nav-item-${navItem.id}`))) }) }));
};
export default BottomNavbar;
